<template>
	<el-card>
		<div slot="header" style="text-align: left;">分类列表</div>
		<div class="col">
			<div class="custom-tree-container">
				<div class="block">
					<el-button type="success" @click='edit("")' size="small" :loading="false">新增顶级分类</el-button>
					<el-row type="flex" class="row-bg"  justify="space-between">
						<el-col :span="3">
							<div class="grid-content bg-purple">分类名称</div>
						</el-col>
						<el-col :span="3">
							<div class="grid-content bg-purple">操作</div>
						</el-col>
					</el-row>
					<!-- default-expand-all 默认全部展开  accordion 是否每次只打开一个同级树节点展开-->
					<el-tree default-expand-all accordion :indent='50' v-loading="loading_dialog" :data="data" :props="props" node-key="id" icon-class='el-icon-arrow-right'
					 :expand-on-click-node="false">
						<template #default="{ node, data }">
							<span class="custom-tree-node">
								<span>{{ node.label }}({{data.lv}})</span>
								<span>
									<!-- 特殊写法  v-if='data.lv<3' 这里写是因为 前台只有三级分类 -->
									<el-button v-if='data.lv<3' type="success" size="mini" @click='addSon(data)'>添加子分类</el-button>
									<el-button type="primary" plain size="mini" @click='edit(data)'>编辑</el-button>
									<el-button type="info" size="mini" @click='release_status(data.name,data.id,data.status)' v-if="data.status==0">已下架</el-button>
									<el-button type="primary" size="mini" @click='release_status(data.name,data.id,data.status)' v-else>已上架</el-button>
									<el-button v-if="this.localGet('userId')==1" type="danger" size="mini" @click='destroy(data.id)'>删除</el-button>
								</span>
							</span>
							<span>&#12288;&#12288;</span>
						</template>
					</el-tree>
				</div>
			</div>
		</div>

	</el-card>

	<el-dialog :title="title" v-model="dialogFormVisible">
		<el-form :model="item" ref="form" :rules="rules">
			<el-form-item label="分类名称" prop="name" :label-width="width">
				<el-input v-model="item.name" size="small" placeholder="分类名称"></el-input>
			</el-form-item>
			<el-form-item label="url名称" prop="home_url_name" :label-width="width">
				<el-input v-model="item.home_url_name" size="small" placeholder="url名称"></el-input>
			</el-form-item>
			<el-form-item label="seo标题" prop="seo_title" :label-width="width">
				<el-input v-model="item.seo_title" size="small" placeholder="seo标题"></el-input>
			</el-form-item>
			<el-form-item label="seo关键词" prop="seo_keywords" :label-width="width">
				<el-input v-model="item.seo_keywords" size="small" placeholder="关键词标题"></el-input>
			</el-form-item>
			<el-form-item label="seo描述" prop="seo_description" :label-width="width">
				<el-input v-model="item.seo_description" size="small" placeholder="关键词标题"></el-input>
			</el-form-item>
			<el-form-item label="分类描述" prop="category_description" :label-width="width">
				<textarea v-model="item.category_description" placeholder="分类描述"></textarea>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="dialogFormVisible = false">取 消</el-button>
			<el-button type="primary" @click="submit()">确 定</el-button>
		</div>
	</el-dialog>
</template>
<script>
	let id = 1000;
	export default {
		name: 'Category',
		data() {
			return {
				width:'90px',
				title: '新增分类',
				dialogFormVisible: false,
				data: [],
				loading_dialog:true,
				props: {
					label: 'name',
					children: 'son'
				},
				item: {
					name: '',
					home_url_name:'',
					seo_title:'',
					seo_keywords:'',
					seo_description:'',
					pid: 0,
					lv: 1
				},
				rules: {
					name: [{
						required: true,
						message: '请填写分类',
						trigger: 'blur'
					}],
					home_url_name: [{
						required: true,
						message: '请填写url名称',
						trigger: 'blur'
					}],
					seo_title: [{
						required: true,
						message: '请填写seo标题',
						trigger: 'blur'
					}],
					seo_keywords: [{
						required: true,
						message: '请填写seo关键词',
						trigger: 'blur'
					}],
					seo_description: [{
						required: true,
						message: '请填写seo描述',
						trigger: 'blur'
					}],
				},
			}
		},
		methods: {
			edit(row) {
				let temp = this.cloneObj(row);
				if (row) {
					this.title = '编辑分类';
					this.item = temp;
				} else {
					this.resetObj(this.item)
					this.item.lv = 1
				}
				this.dialogFormVisible = true;

				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			addSon(data) {
				this.resetObj(this.item)
				// console.log(data);
				this.title = '新增子分类';
				let temp = this.cloneObj(data)
				this.item.pid = temp.id // 下一级分类 pid  为上一级的 id
				this.item.lv = ++temp.lv
				this.dialogFormVisible = true;
			},
			release_status(name,id,status){
				console.log(name)
				console.log(id)
				let release_name = ''
				if(status==0){
					this.release_name = '上架'
				}else{
					this.release_name = '下架'
				}
				this.msgBoxAjax('是否将:'+name+this.release_name, '确定更改吗?', '/admin/category/categoryReleaseStatus', {
					id: id,
					status:status
				}).then((re) => {
					if (re.code > 1) return this.$message.error(re.msg)
					this.alertSuccess('成功')
					this.getCategoryList()
				})
			},
			destroy(id) {
				this.msgBoxAjax('警告', '确定删除吗?', '/admin/category/categoryDelete', {
					id: id
				}).then((re) => {
					if (re.code > 1) return this.$message.error(re.msg)
					this.getCategoryList()
				})
			},
			getCategoryList() {
				this.loading = true
				this.httpPost({
					url: '/admin/category/categoryList',
					data:{
						routePath: this.$route.path
					}
				}).then((re) => {
					let data = re.data
					console.log(data)
					let temp = this.cloneObj(data);
					this.data = temp;
					this.loading = false;
					this.loading_dialog = false

				}).catch((err) => {
					this.loading = false;
				})
			},
			submit() {
				console.log(this.item);
				// return false;

				this.$refs['form'].validate((valid) => {
					if (valid) {
						this.httpPost({
							url: '/admin/category/categoryUpdate',
							data: this.item
						}).then((re) => {
							// console.log(re);
							if (re.code > 1) return this.alertWarn('错误')
							this.alertSuccess('成功')
							this.dialogFormVisible = false;
							this.resetObj(this.item)
							this.getCategoryList();
						}).catch((err) => {
							this.alertWarn('失败')
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				})

			},
		},
		created() {
			this.getCategoryList();
		}
	}
</script>

<style>
	.custom-tree-node {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		padding-right: 8px;
	}

	.el-tree-node__content {
		height: 35px;
	}

	.el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    /* background: #d3dce6; */
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
	line-height: 36px;
	/* text-align: left; */
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
  .el-icon-arrow-right{
	  color: red;
	  font-size: 10px;
  }
</style>
